

























import { namespace } from "vuex-class";
import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from "vue-property-decorator";

import { Match, Token } from "@/types";
import BaseToken from "@/components/BaseToken.vue";

const { isEqual } = require("lodash");

const Details = namespace("details");

@Component({
  components: { BaseToken }
})
export default class MatchedDocument extends Vue {
  private parsed: any[][] = [];

  @Prop({ required: true })
  private matches!: Match[];

  @Prop({ type: Object })
  private data!: { tokens: Token[]; blocks: number[][] };

  @Prop({ type: Array })
  private selectedConceptIds!: string[];

  private isEqual = isEqual;

  @Emit("select")
  select(value: Match) {}

  @Watch("data")
  onDataUpdate() {
    this.update();
  }

  @Watch("matches")
  update() {
    this.parsed = this.blocks.map(block =>
      block.reduce((clusters: any[], index: number) => {
        if (
          clusters.length === 0 ||
          !isEqual(this.matches[index], this.matches[index - 1])
        ) {
          clusters.push({
            token: this.tokens[index],
            match: this.matches[index]
          });
        } else {
          const partial = clusters[clusters.length - 1].token;

          clusters[clusters.length - 1].token = {
            index: partial.index,
            text: partial.text + partial.delimiter + this.tokens[index].text,
            delimiter: this.tokens[index].delimiter,
            span: [partial.span[0], this.tokens[index].span[1]]
          };
        }

        return clusters;
      }, [])
    );
  }

  mounted() {
    this.update();
  }

  get tokens() {
    return (this.data && this.data.tokens) || this.$store.state.tokens;
  }

  get blocks() {
    return (this.data && this.data.blocks) || this.$store.state.blocks;
  }

  get selected() {
    if (this.selectedConceptIds) return this.selectedConceptIds;

    if (this.$store.state.details.match)
      return [this.$store.state.details.match.concept.conceptid];

    return null;
  }
}
